module.exports = __webpack_public_path__ + "img/SongJiang.bc4ee1b2.png";